import { CircularProgress, Table, TableHead, TableBody, TableCell, Typography, makeStyles, Grid, TableRow, Checkbox, Select, MenuItem, FormControl } from '@material-ui/core';
import { getUsers, updateUser } from '../../api/user';
import NotFound from '../../components/NotFound';
import { User, UserRole } from '../../domain/domain';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../reducers';
import { compose } from 'redux';
import { Link } from 'react-router-dom';


const useStyles = makeStyles(_ => ({
    root: {
        maxWidth: '80%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 20
    },
    columnTitle: {
        fontWeight: 'bold'
    },
    select: {
        width: 200
    }
}));

type Props = {
    currentUser: User
}

const UserManagementPage : React.FC<Props> = ({currentUser}) => {

    const classes = useStyles();
    const [users, setUsers] = useState<User[] | undefined>(undefined);
    
    useEffect(() => {
        getUsers().then(response => {
            setUsers(response.data);
        }).catch(error => {
            console.error(error);
        })
    }, []);

    if (currentUser.userRole !== UserRole.ADMINISTRATOR) {
        return <NotFound />
    }

    if (!users) {
        return <CircularProgress />
    }

    return (
        <Grid container direction='column' className={classes.root} alignItems="center" spacing={4}>
            <Grid item>
                <Link to='/admin'>Administrator Page</Link>
            </Grid>            
            <Grid item>
                <Table size="small">
                    <TableHead>
                        <TableCell>
                            <Typography className={classes.columnTitle}>Username</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography className={classes.columnTitle}>Role</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography className={classes.columnTitle}>Email</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography className={classes.columnTitle}>Registered</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography className={classes.columnTitle}>Last Login</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography className={classes.columnTitle}>Active</Typography>
                        </TableCell>
                    </TableHead>
                    <TableBody>
                        {users.map(u => {
                            return (
                                <TableRow>
                                    <TableCell>
                                        <Typography>{u.username}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <FormControl size='small'>
                                            <Select
                                                value={u.userRole}
                                                variant='outlined'
                                                disabled={u.id === currentUser.id}
                                                className={classes.select}
                                                // disabled={!}
                                                onChange={(event) => {
                                                    u.userRole = event.target.value as UserRole;
                                                    updateUser(u).then(response => {
                                                        let idx = users.findIndex(u => u.id === response.data.id);
                                                        if (idx >= 0) {
                                                            let newUsers = [...users];
                                                            newUsers[idx] = response.data;
                                                            setUsers(newUsers);
                                                        }
                                                    }).catch(error => {
                                                        console.error(error);
                                                    })
                                                }}
                                            >
                                                <MenuItem value={UserRole.NON_PUBLICATIONS_TEAM}>Non-Publications Team</MenuItem>
                                                <MenuItem value={UserRole.PUBLICATIONS_TEAM}>Publications Team</MenuItem>
                                                <MenuItem value={UserRole.ADMINISTRATOR}>Publications Administrator</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </TableCell>
                                    <TableCell><Typography>{u.email}</Typography></TableCell>
                                    <TableCell><Typography>{u.registeredDate ? moment(u.registeredDate).format('DD.MM.YYYY HH:mm:ss') : '-'}</Typography></TableCell>
                                    <TableCell><Typography>{u.lastLoginDate ? moment(u.lastLoginDate).format('DD.MM.YYYY HH:mm:ss'): '-'}</Typography></TableCell>
                                    <TableCell><Typography>
                                        <Checkbox
                                            checked={u.userActive}
                                            disabled={u.id === currentUser.id}
                                            onChange={(event: any) => {
                                                u.userActive = event.target.checked;
                                                updateUser(u).then(response => {
                                                    let idx = users.findIndex(u => u.id === response.data.id);
                                                    if (idx >= 0) {
                                                        let newUsers = [...users];
                                                        newUsers[idx] = response.data;
                                                        setUsers(newUsers);
                                                    }
                                                }).catch(error => {
                                                    console.error(error);
                                                })
                                            }}
                                        />    
                                    </Typography></TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </Grid>
        </Grid>
    )
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        currentUser: state.user.currentUser
    };
};

export default compose<any>(
    connect(mapStateToProps, null)
)(UserManagementPage);